module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"flyTo":"Найти на карте"},"en":{"flyTo":"Find on map"}}')
  delete Component.options._Ctor
}
